export default {
  isLoading: false,
  hasError: false,
  agents: [],
  permissionsPresets: {},
  newAgentForm: {
    firstName: "",
    lastName: "",
    email: "",
  },
};
